import { CallStatus } from "@prisma/client";
import { useState } from "react";
import IconFilter from "@/app/(components)/generics/Icons/IconFilter";
import Popover from "@/app/(components)/generics/Popover/Popover";
import PopoverContent from "@/app/(components)/generics/Popover/PopoverContent";
import PopoverTrigger from "@/app/(components)/generics/Popover/PopoverTrigger";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { UStyles } from "@/app/utils/UStyles";
import styles from "./StatusFilter.module.css";

type Props = {
  value: CallStatus | null | undefined;
  onChange: (status: CallStatus | null | undefined) => void;
  lang: string;
};

export default function StatusFilter(props: Props) {
  const T = useT();
  const { value, onChange } = props;
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (status: CallStatus | null | undefined) => {
    onChange(status);
    setIsOpen(false);
  };

  const allStatuses = Object.values(CallStatus);

  return (
    <Popover
      isVisible={isOpen}
      setIsVisible={setIsOpen}
      openAfterClick={true}
      closeWhenClickOutside={true}
      isPortaled={true}
    >
      <PopoverTrigger>
        <span className={UStyles.classNames(styles.trigger, value !== undefined && styles.active)}>
          <IconFilter size={13} />
        </span>
      </PopoverTrigger>

      <PopoverContent position={{ default: { top: "8px", right: "0px" } }}>
        <div className={styles.popoverContent}>
          <div className={styles.list}>
            <div
              className={UStyles.classNames(styles.item, value === undefined && styles.itemActive)}
              onClick={() => handleSelect(undefined)}
            >
              {T(TKey.CALL_ANALYSIS_FILTER_ALL)}
            </div>
            {allStatuses.map((status) => (
              <div
                key={status}
                className={UStyles.classNames(styles.item, value === status && styles.itemActive)}
                onClick={() => handleSelect(status)}
              >
                {T(`CALL_ANALYSIS_STATUS_${status}` as TKey)}
              </div>
            ))}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
